export default __webpack_public_path__ + "static/qaHeroQuality-e4c433b92e4f882a6862cd16401c7c8b.png";